const SERVER_URL =
    // process.env.REACT_APP_SERVER_URL ||
    window.location.host.includes('localhost')
        ? 'http://localhost:3300'
        : window.location.protocol + '//' + window.location.host

const BASE_URL = SERVER_URL + '/api/v1' //'http://localhost:3300/'

const baseUrl = process.env.NODE_ENV === 'test' ? 'http://localhost:3300/api/v1' : BASE_URL

export default baseUrl
